import { Box, Link, Stack, Typography } from "@mui/material";
import { TableOfContentsSection } from "./types";

export default function TableOfContents({
  sections,
}: {
  sections: TableOfContentsSection[];
}) {
  const handleNavClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    sectionId: string,
  ) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      document.documentElement.style.scrollBehavior = "auto";
      element.scrollIntoView();
    }
  };

  return (
    <Box
      sx={{
        flexShrink: 0,
        width: 240,
        mr: 2,
        display: { xs: "none", md: "block" },
        "@media print": {
          display: "none",
        },
      }}
    >
      <Box
        sx={{
          position: "fixed",
          width: 240,
          height: "100%",
          bgcolor: "grey.100",
          p: 1,
        }}
      >
        <Box
          sx={{
            bgcolor: "background.paper",
            borderRadius: 2,
            py: 2,
            px: 1.5,
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              width: "3px",
            },
          }}
        >
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>
            Contents
          </Typography>
          <Stack spacing={0.25}>
            {sections.map(({ id, label, isPlayer }) => (
              <Link
                key={id}
                href={`#${id}`}
                onClick={(e) => handleNavClick(e, id)}
                sx={{
                  color: isPlayer ? "text.secondary" : "text.primary",
                  textDecoration: "none",
                  fontSize: "0.95rem",
                  py: 0.5,
                  pl: isPlayer ? 2 : 0,
                  "&:hover": {
                    color: "primary.main",
                  },
                }}
              >
                {label}
              </Link>
            ))}
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}
